import { PageLayout } from '@kizi/comparator-core';
import { usp } from './overview';

const checkoutLayout: PageLayout = {
  name: 'checkout',
  components: [
    {
      type: 'CheckoutPageWrapper',
      props: {
        bg: '#FFF',
        promoSection: [
          {
            type: 'Hero',
          },
          {
            type: 'HappinessSection',
          },
          {
            type: 'CrossSellGroup',
            props: {
              cards: [
                {
                  title: 'Autoverzekering',
                  subTitle: 'Bespaar tot € 265,-',
                  iconName: 'car',
                  anchor: {
                    label: 'Check nu',
                    url: 'https://www.overstappen.nl/autoverzekering/?ref=cross_bedank_zorg_auto',
                  },
                },
                {
                  title: 'Energie',
                  subTitle: 'Bespaar tot € 900,-',
                  iconName: 'energy',
                  anchor: {
                    label: 'Check nu',
                    url: 'https://www.overstappen.nl/energie/vergelijken/?ref=cross_bedank_zorg_energie',
                  },
                },
                {
                  title: 'Woonverzekering',
                  subTitle: 'Bespaar tot € 385,-',
                  iconName: 'home',
                  anchor: {
                    label: 'Check nu',
                    url: 'https://www.overstappen.nl/woonverzekering/?ref=cross_bedank_zorg_woon',
                  },
                },
              ],
            },
          },
          {
            type: 'AFMBanner',
          },
        ],
        loadingPage: {
          bg: 'second.2',
          contentStyles: {
            width: [null, null, null, '1180px'],
            maxWidth: '100vw',
            mt: '64px',
            mx: 'auto',
            span: [12, 12, 12, 12],
          },
          content: [
            {
              type: 'Div',
              props: {
                maxWidth: 310,
                minHeight: '100vh',
                margin: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              },
              _children: [
                {
                  type: 'Div',
                  props: {
                    mt: '35%',
                  },
                  _children: [
                    {
                      type: 'Spinner',
                      props: {
                        marginBottom: '24px',
                        width: '48px',
                        height: '48px',
                        color: '#D8D8D8',
                      },
                    },
                    {
                      type: 'Heading',
                      props: {
                        as: 'h4',
                        variant: 'H4',
                        color: '#2B2F3B',
                        fontSize: '24px !important',
                        m: 0,
                        children: 'Een momentje je aanvraag wordt verstuurd...',
                      },
                    },
                    {
                      type: 'Div',
                      props: {
                        mt: '24px',
                      },
                      _children: [
                        usp('Met gratis opzegservice'),
                        usp('14 dagen bedenktijd'),
                        usp('Binnen 2 minuten geregeld'),
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      },
    },
  ],
};

export default checkoutLayout;
